module.exports = __webpack_public_path__ + "static/img/2.74ade4c.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/7/eng/2.png
// module id = HAuU
// module chunks = 0